import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nx-averycom-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
